import React, { useRef, useEffect, useState } from 'react';
import { TableContainer, Table, TableHead, TableCell, TableRow, Paper, TableBody, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { downloadDocument, getBiocharCollection } from '../../../../../actions/tigercat-burns/tigercat-actions';
import Tooltip from '@mui/material/Tooltip';
import Paginator from '../../../../layout/Pagination';
import useTsPaginator from 'ts-paginator';
const TruncatedText = React.forwardRef(({ children, ...spanProps }, ref) => {
    const innerRef = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
        const el = innerRef.current;
        if (el) {
            setIsTruncated(el.scrollWidth > el.clientWidth);
        }
    }, [children]);

    // Forward the ref for Tooltip, but use innerRef for measuring
    return (
        <span
            ref={node => {
                innerRef.current = node;
                if (typeof ref === 'function') ref(node);
                else if (ref) ref.current = node;
            }}
            style={{
                display: 'inline-block',
                maxWidth: 120,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                verticalAlign: 'bottom',
                fontWeight: isTruncated ? 'bold' : 'normal',
                textDecoration: isTruncated ? 'underline' : 'none',
                cursor: 'pointer'
            }}
            {...spanProps}
        >
            {children}
        </span>
    );
});
TruncatedText.displayName = 'TruncatedText';

const BiocharCollection = ({ projectId, project }) => {
    const dispatch = useDispatch()

    const biocharCollections = useSelector(state => state.tigercatBurnsReducer.biocharCollection.data)
    const tableRecordCount = useSelector(state => state.tigercatBurnsReducer.biocharCollection?.pagination?.total_records)

    const {
        totalRecordCount,
        rowsPerPage,
        currentPage,
        _determinePaginationMessage,
        _determinePaginationDisabledState,
        // _determinePaginationPages,
        _determineRowsPerPageOptions,
        _handleChangeTotalRecordCount,
        _handleChangeRowsPerPage,
        _handleChangePage,
    } = useTsPaginator(+tableRecordCount || 0, 0);

    useEffect(() => {
        dispatch(getBiocharCollection(projectId, 'supersacks', +rowsPerPage, +currentPage));
    }, [dispatch, projectId, rowsPerPage, currentPage])


    useEffect(() => {
        // if (currentProjectId !== projectId) {
        _handleChangePage(0); // Reset to the first page
        _handleChangeRowsPerPage(10)
        _handleChangeTotalRecordCount(+tableRecordCount, +rowsPerPage, +currentPage); // Reset to the first page
        // }
    }, [projectId, tableRecordCount]);

    const handleDownload = async () => {
        try {
            dispatch(downloadDocument(projectId, 'biochar_collection_supersacks')).then((response) => {

                // Create a downloadable link for the Excel file
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${project}_biochar_collection_supersacks.xlsx`); // Set the file name
                document.body.appendChild(link);
                link.click();
                link.remove();
            })

        } catch (err) {
            console.error('Error downloading Biochar Collection Supersacks:', err);
        }
    };



    return (<>
        <h2>Biochar Collection Supersacks</h2>
        <TableContainer key={0} component={Paper} sx={{ height: 'auto' }}>
            <Button variant='contained' sx={{ height: 'auto', float: 'right', mt: 2, mb: 2 }} onClick={handleDownload}>Download Excel</Button>
            <Table aria-label="simple table" sx={{ tableLayout: 'fixed', width: '100%' }}>
                <TableHead>
                    <TableRow>
                        {/* <TableCell size="small" align="left">
                            User
                        </TableCell> */}
                        <TableCell size="small" align="left">
                            Date
                        </TableCell>
                        <TableCell size="small" align="left">
                            Entity Name
                        </TableCell>
                        <TableCell size="small" align="left">
                            Destination Address
                        </TableCell>
                        <TableCell size="small" align="left">
                            Entity Email
                        </TableCell>
                        <TableCell size="small" align="left">
                            Entity Contact
                        </TableCell>
                        <TableCell size="small" align="left">
                            Supersacks Dispatched
                        </TableCell>
                        <TableCell size="small" align="left">
                            Transport Method
                        </TableCell>
                        <TableCell size="small" align="left">
                            Distance
                        </TableCell>
                        <TableCell size="small" align="left">
                            Biochar Intended Use
                        </TableCell>
                        <TableCell size="small" align="left">
                            Collection Notes
                        </TableCell>
                        <TableCell size="small" align="left" sx={{ maxWidth: 20 }}>
                            Non-combustion Confirmation
                        </TableCell>
                        <TableCell size="small" align="left">
                            Biochar Loaded Photo
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {biocharCollections?.map((data, index) => {
                        return (
                            <TableRow key={index}>
                                {/* <TableCell size="small" align="left" sx={{ overflowWrap: 'break-word' }}>{data.user_name}</TableCell> */}
                                <TableCell size="small" align="left">{data.created_at.split('T')[0]}</TableCell>
                                <TableCell size="small" align="left">
                                    {data.entity_name.length > 16 && data.entity_name !== 'null' ?
                                        <Tooltip
                                            slotProps={{
                                                tooltip: {
                                                    sx: { fontSize: 18 } // Set your desired font size here
                                                }
                                            }}
                                            title={data.entity_name && data.entity_name !== 'null' ? data.entity_name : ''}>
                                            <TruncatedText>
                                                {data.entity_name && data.entity_name !== 'null' ? data.entity_name : ''}
                                            </TruncatedText>
                                        </Tooltip>
                                        : data.entity_name.length <= 16 && data.entity_name !== 'null' ? data.entity_name : ''}
                                </TableCell>
                                <TableCell size="small" align="left">{data.destination_address}</TableCell>
                                <TableCell size="small" align="left">
                                    {data.entity_email.length > 16 && data.entity_email !== 'null' ?
                                        <Tooltip
                                            slotProps={{
                                                tooltip: {
                                                    sx: { fontSize: 18 } // Set your desired font size here
                                                }
                                            }}
                                            title={data.entity_email && data.entity_email !== 'null' ? data.entity_email : ''}>
                                            <TruncatedText>
                                                {data.entity_email && data.entity_email !== 'null' ? data.entity_email : ''}
                                            </TruncatedText>
                                        </Tooltip>
                                        : data.entity_email.length <= 16 && data.entity_email !== 'null' ? data.entity_email : ''}
                                </TableCell>
                                <TableCell size="small" align="left">{data.contact_number == 'null' ? '' : data.contact_number}</TableCell>
                                <TableCell size="small" align="left">{data.supersacks_loaded}</TableCell>
                                <TableCell size="small" align="left">{data.transportation_method}</TableCell>
                                <TableCell size="small" align="left">{data.transportation_distance == 'null' ? '' : data.transportation_distance}</TableCell>
                                <TableCell size="small" align="left">{data.intended_use}</TableCell>
                                <TableCell size="small" align="left">
                                    {data?.collection_notes?.length > 16 && data?.collection_notes !== 'null' ?
                                        <Tooltip
                                            slotProps={{
                                                tooltip: {
                                                    sx: { fontSize: 18 } // Set your desired font size here
                                                }
                                            }}
                                            title={data?.collection_notes && data?.collection_notes !== 'null' ? data?.collection_notes : ''}>
                                            <TruncatedText>
                                                {data?.collection_notes && data?.collection_notes !== 'null' ? data?.collection_notes : ''}
                                            </TruncatedText>
                                        </Tooltip>
                                        : data?.collection_notes?.length <= 16 && data?.collection_notes !== 'null' ? data?.collection_notes : ''}
                                </TableCell>
                                <TableCell size="small" align="left" sx={{ maxWidth: 20 }}>{data.will_be_burned_or_incinerated ? 'No' : 'Yes'}</TableCell>
                                <TableCell size="small" align="left">
                                    {data.biochar_loaded_photo ? (
                                        <a href={data.biochar_loaded_photo} target="_blank" rel="noopener noreferrer">
                                            Photo
                                        </a>
                                    ) : 'N/A'}
                                </TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </TableContainer>
        <Paginator
            totalRecordCount={totalRecordCount}
            rowsPerPage={rowsPerPage}
            currentPage={currentPage}
            handleChangePage={_handleChangePage}
            handleChangeRowsPerPage={_handleChangeRowsPerPage}
            determinePaginationMessage={_determinePaginationMessage}
            determinePaginationDisabledState={_determinePaginationDisabledState}
            determineRowsPerPageOptions={_determineRowsPerPageOptions}
        />
    </>

    )
}

export default BiocharCollection